import { withAuthenticationRequired } from 'react-oidc-context';
import { Route } from 'react-router-dom';
import Loader from 'components/Loader';

const OAuthSecureRoute = withAuthenticationRequired(Route, {
  OnRedirecting: () => <Loader />,
});

export default OAuthSecureRoute;
